import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import Breadcrumb from '../../shared/Breadcrumb';
import PatientInfo from './PatientInfo';
import ViewPrescription from './ViewPrescription';

const ViewPrescriptionContainer = (props) => {
    const doctor = JSON.parse(props.location.state.doctor);
	const patient = JSON.parse(props.location.state.patient);
	const prescriptionId = JSON.parse(props.location.state.prescriptionId);

    const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    return ( 
        <div>
            <Breadcrumb title="View Prescription" />
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                            <PatientInfo patient={patient}></PatientInfo>
                        </div>
                        <iframe id="ifmcontentstoprint" style={{position: "absolute", height: "0px", width: "0px" }}></iframe>
                        <div className="col-md-7 col-lg-8 col-xl-9" id="divcontents">
                            <ViewPrescription doctor={doctor} patient={patient} prescriptionId={prescriptionId} ref={componentRef} />
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className="submit-section" style={{marginBottom: '5px'}}>
                                        <button className="btn btn-primary submit-btn" onClick={handlePrint}>Print</button>
                                        <Link className="btn btn-primary submit-btn" 
                                            to={
                                                {
                                                    pathname:'/PatientProfile',
                                                    state: {
                                                        patientId: patient.patientId
                                                    }
                                                }
                                            }>Go Back</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default ViewPrescriptionContainer;